class ProductCard extends WiroProductCard {
  constructor() {
    super();
    this._openerBlurHandler = null;
    this.availabilityCache = null;
  }

  setProduct(product) {
    this.product = product;
  }

  setAvailabilityCache(cache) {
    this.availabilityCache = cache;
  }

  _dataBool(name, defaultValue = false) {
    if (!this.dataset) return defaultValue;
    const v = this.dataset[name];
    if (v === undefined) return defaultValue;
    return String(v) === "true";
  }

  _dataStr(name, fallback = "") {
    return this.dataset && this.dataset[name] !== undefined ? this.dataset[name] : fallback;
  }

  _decodeHtmlEntities(str) {
    if (!str) return str;
    if (typeof str !== "string") return str;

    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  _renderRating(okendo_summarydata) {
    if (!okendo_summarydata) {
      return `<div class="tw-h-[15px] !tw-block sm:!tw-hidden"></div>`;
    }

    try {
      if (typeof okendo_summarydata === "object") {
        const { reviewCount = 0, reviewAverageValue = 0 } = okendo_summarydata;
        if (!Number(reviewCount)) {
          return `<div class="tw-h-[15px] !tw-block sm:!tw-hidden"></div>`;
        }
        return this._buildRatingHtml(parseFloat(reviewAverageValue) || 0, Number(reviewCount));
      }

      let raw = String(okendo_summarydata).trim();

      const decoded = this._decodeHtmlEntities(raw);

      let jsonStr = decoded;
      if (jsonStr.startsWith('"') && jsonStr.endsWith('"')) {
        jsonStr = jsonStr.slice(1, -1).replace(/\\"/g, '"');
      }

      const data = JSON.parse(jsonStr);
      const reviewCount = Number(data.reviewCount) || 0;
      const reviewAverageValue = parseFloat(data.reviewAverageValue) || 0;

      if (!reviewCount) return `<div class="tw-h-[15px] !tw-block sm:!tw-hidden"></div>`;

      return this._buildRatingHtml(reviewAverageValue, reviewCount);
    } catch (err) {
      console.error("Error parsing okendo_summarydata", err, okendo_summarydata);
      return "";
    }
  }

  _buildRatingHtml(ratingValue, reviewCount) {
    const scaleMax = 5;
    const decimal = ratingValue % 1;
    let rating_decimal = 0;
    if (decimal >= 0.3 && decimal <= 0.7) rating_decimal = 0.5;
    else if (decimal > 0.7) rating_decimal = 1;

    return `
    <div class="rating-wrapper tw-leading-none">
      <div
        class="rating"
        role="img"
        aria-label="${ratingValue.toFixed(1)} out of ${scaleMax} stars"
      >
        <span
          aria-hidden="true"
          class="rating-star"
          style="--rating: ${Math.floor(ratingValue)}; --rating-max: ${scaleMax}; --rating-decimal: ${rating_decimal};"
        ></span>
      </div>
    </div>
  `;
  }

  _renderAvailable(size_available) {
    if (!size_available || size_available <= 0) {
      return `<div class="tw-h-[18px] !tw-block sm:!tw-hidden"></div>`;
    }
    return `<p class="tw-text-body tw-text-[#444444]">Available in ${size_available} sizes</p>`;
  }

  _getBrandLogo(brandName, brandCollab = null) {
    if (!window.brandLogos) return null;

    const logos = Object.fromEntries(Object.entries(window.brandLogos).map(([k, v]) => [String(k).toLowerCase(), v]));

    if (brandCollab) {
      try {
        let str;
        if (typeof brandCollab === "string") {
          str = brandCollab;
        } else if (Array.isArray(brandCollab)) {
          str = brandCollab.join(",");
        } else {
          str = String(brandCollab);
        }

        const gidRegex = /gid:\/\/shopify\/Metaobject\/(\d+)/g;
        const ids = [];
        let m;
        while ((m = gidRegex.exec(str)) !== null) {
          ids.push(m[1]);
        }

        if (ids.length) {
          const found = ids.map((id) => logos[String(id).toLowerCase()]).filter(Boolean);

          if (found.length) {
            return found.map(
              (item) => `<img src="${item.logo}" alt="${item.name}" class="tw-h-[22px] tw-object-contain tw-w-auto" />`,
            )
              .join(`<span class="tw-text-[#A1A1A1]"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_23619_26915)">
              <path d="M6.875 2.00391L2.375 6.50391" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.875 6.50391L2.375 2.00391" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_23619_26915">
              <rect width="8" height="8" fill="white" transform="translate(0.625 0.253906)"/>
              </clipPath>
              </defs>
              </svg>
              </span>`);
          }
        }
      } catch (err) {
        console.warn("Error parsing brandCollab:", err, brandCollab);
      }
    }

    if (!brandName) return null;
    const key = brandName.trim().toLowerCase();
    const found = logos[key];
    if (!found) return null;
    return `<img src="${found.logo}" alt="${found.name}" class="tw-h-[22px] tw-object-contain tw-w-auto" />`;
  }

  optimizeShopifyImage(url, width) {
    if (!url || !url.includes("cdn.shopify.com")) return url;
    const baseUrl = url.split("?")[0];
    return `${baseUrl}?width=${width}`;
  }

  generateSrcset(url) {
    return [250, 350].map((w) => `${this.optimizeShopifyImage(url, w)} ${w}w`).join(", ");
  }
  ensureModal(modalId, label, opts = {}) {
    if (document.getElementById(modalId)) return;

    const safeTitle = String(label).replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const modalMarkup = `
      <quick-add-modal id="${modalId}" class="quick-add-modal" data-section="${opts.quickAddSection || "cart-carousel"}">
        <div role="dialog" aria-label="Choose options for ${safeTitle}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
          <div class="tw-relative">
            <button id="ModalClose-${modalId}" type="button" class="quick-add-modal__toggle quick-add-modal__toggle !tw-sticky sm:tw-h-0 tw-h-12 max-sm:tw-w-full max-sm:!tw-top-0 max-sm:tw-bg-[#fcfbf7] max-sm:!tw-pr-3 sm:tw-left-[calc(100%-40px)]" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M18 6.59375L6 18.5938M6 6.59375L18 18.5938" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path>
              </svg>
            </button>
            <div id="QuickAddInfo-${modalId}" class="quick-add-modal__content-info"></div>
          </div>
        </div>
      </quick-add-modal>
    `.trim();

    const appendModal = () => {
      if (document.getElementById(modalId)) return;
      const tpl = document.createElement("template");
      tpl.innerHTML = modalMarkup;
      const modalEl = tpl.content.firstElementChild;

      const nearestSection =
        (this.closest && this.closest(".shopify-section")) || document.querySelector(".shopify-section");
      const target = nearestSection || document.body;

      target.appendChild(modalEl);
    };

    if (customElements.get("quick-add-modal")) {
      appendModal();
    } else if (customElements.whenDefined) {
      customElements.whenDefined("quick-add-modal").then(appendModal).catch(appendModal);
    } else {
      appendModal();
    }
  }

  formatPriceForDisplay(rawPrice) {
    const sym = this._dataStr("currencySymbol", "£");
    const n = Number(rawPrice) || 0;
    return `${sym}${n.toFixed(2)}`;
  }

  async connectedCallback() {
    if (!this.product) return;

    const boost = this.parseBoostAPIProductData ? this.parseBoostAPIProductData() : this.product?.mappings?.core || {};
    const name = boost.name || "";
    const url = boost.url || "#";
    let imageList = [];
    if (boost.images) {
      imageList = String(boost.images)
        .split("|")
        .map((url) => url.trim())
        .filter((u) => u.length > 0);
    }
    const primaryImage = imageList[0] || boost.thumbnailImageUrl || "";
    const secondaryImage = imageList[1] || null;
    const price = Number(boost.price) || 0;
    const msrp = Number(boost.msrp ?? 0) || 0;
    const brand = boost.brand || "";
    const okendo_summarydata = boost.okendo_summarydata || "";
    const size_available = boost.size_available;
    const brand_collab = boost.brand_collab;

    const showBrand = this._dataBool("showBrand", true);
    const showMsrp = this._dataBool("showMsrp", true);
    const showQuickAdd = this._dataBool("showQuickAdd", true);
    const quickAddSection = this._dataStr("quickAddSection", this._dataStr("quickaddSection", "cart-carousel"));
    const badgeText = this._dataStr("badgeText", this._dataStr("badgetext", "SALE"));
    const badgeColor = this._dataStr("badgeColor", this._dataStr("badgecolor", "#E41613"));
    const ns = this._dataStr("ns", "wiro");

    const onSale = msrp > price;

    const modalId = `${ns}-QuickAdd-${this.product.id}`;
    if (showQuickAdd) {
      this.ensureModal(modalId, name, { quickAddSection });
    }

    const availableResult = this._renderAvailable(size_available);
    const ratingResult = this._renderRating(okendo_summarydata);

    const badgeHtml =
      onSale && badgeText
        ? `<span class="tw-absolute tw-top-2 tw-left-2 sm:tw-top-3 sm:tw-left-3 tw-font-semi-bold tw-font-bold tw-text-body tw-text-white tw-px-2 tw-py-1 tw-rounded-[4px]" style="background:${badgeColor}">${badgeText}</span>`
        : "";

    const brandLogoHtml = this._getBrandLogo(brand, brand_collab);
    const brandHtml =
      showBrand && brandLogoHtml
        ? `<div class="card__brand-wrap tw-flex tw-items-center tw-gap-2">${brandLogoHtml}</div>`
        : `<div class="card__brand-wrap no-brand"></div>`;

    const priceHtml = `
        <div class="tw-flex tw-items-center tw-gap-1">
          <span class="tw-text-small tw-text-[#444444]">From</span>
          <span class="tw-text-body tw-font-semibold tw-font-semi-bold ${onSale ? "tw-text-[#E41613]" : "tw-text-black"}">
            ${this.formatPriceForDisplay(price)}
          </span>
          ${
            showMsrp && onSale
              ? `<span class="tw-text-small tw-line-through tw-text-[#A1A1A1]">${this.formatPriceForDisplay(msrp)}</span>`
              : ""
          }
        </div>
      `;

    const cardHtml = `
<div class="product tw-group tw-transition-all tw-duration-300 tw-flex tw-flex-col tw-h-full tw-relative">
  <a href="${url}" class="tw-block tw-relative tw-pb-3 sm:tw-pb-4">
    <div class="tw-relative tw-bg-brand-secondary tw-rounded-[4px] product-card__image-wrapper">
      <img
        src="${this.optimizeShopifyImage(primaryImage, 350)}"
        srcset="${this.generateSrcset(primaryImage)}"
        sizes="(min-width: 990px) 350px, (min-width: 750px) 250px, 200px"
        loading="lazy"
        alt="${name}"
        class="product-card__image product-card__image--primary ${this.dataset.additionalImagePadding ? "tw-p-4 sm:tw-p-8" : "sm:tw-p-6 tw-p-4"} tw-w-full tw-aspect-1/1 tw-object-cover tw-transition-all tw-duration-500 tw-mix-blend-multiply"
      />
      ${
        secondaryImage
          ? `<img               
        src="${this.optimizeShopifyImage(secondaryImage, 350)}" 
        srcset="${this.generateSrcset(secondaryImage)}"
        sizes="(min-width: 990px) 350px, (min-width: 750px) 250px, 200px"
        loading="lazy"
        alt="${name}" 
        class="product-card__image product-card__image--secondary ${this.dataset.additionalImagePadding ? "tw-p-4 sm:tw-p-8" : "sm:tw-p-6 tw-p-4"} tw-w-full tw-aspect-1/1 tw-object-cover tw-absolute tw-inset-0 tw-opacity-0 tw-transition-all tw-duration-500 tw-mix-blend-multiply" />`
          : ""
      }
      ${badgeHtml}
    </div>
  </a>

  <div class="tw-flex tw-flex-col tw-gap-2 tw-items-start lg:tw-relative tw-grow">
    <div class="tw-flex tw-flex-col tw-gap-1 tw-w-full tw-relative">
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-2 sm:tw-pr-2">
        <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
          ${brandHtml}
          <h3 class="tw-text-body tw-font-semi-bold tw-font-semibold card__title tw-text-black">
            <a href="${url}" class="full-unstyled-link tw-line-clamp-2">
              ${name}
            </a>
          </h3>
        </div>

        ${
          showQuickAdd
            ? `
        <div class="tw-relative tw-w-[40px] tw-h-[40px] tw-flex-shrink-0 max-sm:tw-hidden">
          <div class="quick-add !tw-z-[0] no-js-hidden sm:!tw-hidden sm:group-hover:!tw-flex tw-absolute tw-inset-0 tw-items-center tw-justify-center">
            <modal-opener data-modal="#${modalId}">
              <button
                id="${ns}-QuickAddBtn-${this.product.id}"
                type="button"
                name="add"
                class="quick-add__submit tw-w-[40px] tw-h-[40px] tw-bg-black tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-[#3C3C3C]"
                aria-haspopup="dialog"
                data-product-url="${url}"
              >
                <span class="icon-wrap tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6L12 18M18 12L6 12" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
                  </svg>
                </span>
                <div class="loading__spinner hidden">
              </button>
            </modal-opener>
          </div>
        </div>
        `
            : ""
        }
      </div>

      ${availableResult}
    </div>
    ${ratingResult}
    ${priceHtml}
    ${
      showQuickAdd
        ? `
          <div class="quick-add !tw-z-[0] no-js-hidden !tw-absolute sm:tw-top-0 sm:tw-right-[8px] sm:!tw-hidden max-sm:tw-bottom-0 max-sm:tw-right-0 !tw-m-0 max-sm:tw-px-2">
            <modal-opener data-modal="#${modalId}">
              <button
                id="${ns}-QuickAddBtn-${this.product.id}"
                type="button"
                name="add"
                class="quick-add__submit tw-w-7 tw-h-7 tw-bg-black tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-[#3C3C3C]"
                aria-haspopup="dialog"
                data-product-url="${url}"
              >
                <span class="icon-wrap tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6L12 18M18 12L6 12" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
                  </svg>
                </span>
                <div class="loading__spinner hidden">
              </button>
            </modal-opener>
          </div>
        `
        : ""
    }
  </div>
</div>
`;

    const dom = this.prepareStringForRender(cardHtml);
    this.render(dom);

    const openerId = `${ns}-QuickAddBtn-${this.product.id}`;
    const openerBtn = this.querySelector ? this.querySelector(`#${openerId}`) : document.getElementById(openerId);
    if (openerBtn) {
      if (this._openerBlurHandler) openerBtn.removeEventListener("click", this._openerBlurHandler, { capture: true });
      this._openerBlurHandler = () => {
        try {
          openerBtn.blur();
        } catch (e) {}
      };
      openerBtn.addEventListener("click", this._openerBlurHandler, { capture: true });
    }
  }

  disconnectedCallback() {
    try {
      if (this._openerBlurHandler) {
        const openerBtns = this.querySelectorAll
          ? this.querySelectorAll(`[id^="${this._dataStr("ns", "wiro")}-QuickAddBtn-"]`)
          : [];
        openerBtns.forEach((b) => b.removeEventListener("click", this._openerBlurHandler, { capture: true }));
      }
    } catch (e) {}

    if (super.disconnectedCallback) super.disconnectedCallback();
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
